export default function Settings() {
  return (
    <div data-testid="admin-settings">
      <h1 className="font-serif text-3xl font-bold">Einstellungen</h1>
      <section className="mt-6 max-w-2xl border border-brand-line bg-brand-cream p-5" aria-labelledby="settings-ms">
        <h2 id="settings-ms" className="font-serif text-xl font-bold">Microsoft-Anmeldung</h2>
        <p className="mt-2 text-sm leading-relaxed text-brand-brown-soft">
          Der Admin-Login läuft über Microsoft Entra ID (OpenID Connect). Die Konfiguration erfolgt über Umgebungsvariablen auf dem Server (Mandanten-ID, Client-ID, Client-Secret, Redirect-URI, Admin-E-Mail). Aus Sicherheitsgründen werden diese Werte hier nicht angezeigt.
        </p>
      </section>
      <section className="mt-6 max-w-2xl border border-brand-line bg-brand-cream p-5" aria-labelledby="settings-backup">
        <h2 id="settings-backup" className="font-serif text-xl font-bold">Daten & Backup</h2>
        <p className="mt-2 text-sm leading-relaxed text-brand-brown-soft">
          Alle Inhalte liegen in der MongoDB-Datenbank (Rezepte, Seiten, Medien-Metadaten, Statistik, Audit-Log). Hochgeladene Bilder liegen im Upload-Verzeichnis des Servers. Für ein vollständiges Backup müssen die Datenbank und das Upload-Verzeichnis gesichert werden.
        </p>
      </section>
    </div>
  );
}
